import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import App from "./components/App";
import store from "./store";
import { DndProvider } from "react-dnd";
import Backend from "react-dnd-html5-backend";
import "./i18n";
import appSettings from "./utils/appSettings";
// import "./styles/tailwind.css";
import "@fortawesome/fontawesome-free/css/all.css";
import "./styles/index.css";

import "./dragAndDropTouch";
import { ApplicationInsights } from "@microsoft/applicationinsights-web";


const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href");
const rootElement = document.getElementById("root");

window.insight = new ApplicationInsights({
  config: {
    instrumentationKey: appSettings.appInsightsKey,
  },
});
window.insight.loadAppInsights();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter basename={baseUrl}>
      <DndProvider backend={Backend}>
        <App />
      </DndProvider>
    </BrowserRouter>
  </Provider>,
  rootElement
);
